const movementTypes = [
  { id: 1, name: 'Secondary', icon: 'secondary' },
  { id: 2, name: 'Primary', icon: 'primary' },
  { id: 3, name: 'Vendor', icon: 'status_vendor' },
  { id: 4, name: 'Return', icon: 'status_return' },
];

const contractTypes = [
  { id: 1, name: 'Per Trip' },
  { id: 2, name: 'Per Ton' },
  { id: 3, name: 'Per Kg' },
  { id: 4, name: 'Per CFT' },
  { id: 5, name: 'Per Package' },
  { id: 6, name: 'Per Case' },
  { id: 7, name: 'Per Box' },
  { id: 8, name: 'Per KM' },
  { id: 9, name: 'Percentage' },
];

module.exports = { movementTypes, contractTypes };
